import { createFieldBase, FieldBase, FieldBaseArguments } from './FieldBase';

export function createFilePickerField({
  file,
  ...options
}: FilePickerFieldArguments): FilePickerField {
  const fieldBase = createFieldBase(options);

  let self: FilePickerField = {
    ...fieldBase,
    componentType: 'file-picker',
    file: file,
  };
  self = {
    ...self,
    get fileName() {
      return getFileName.call(self);
    },
    get fileContent() {
      return getFileContent.call(self);
    },
  };

  return self;
}

// functions
function getFileName() {
  return this.newName || this.file.currName || null;
}

function getFileContent() {
  return this.file.newContent || this.file.currContent || null;
}

// TYPES:
export interface FilePickerField extends FieldBase {
  componentType: string;
  file: FileInfo;
  readonly fileName?: string;
  readonly fileContent?: string;
}

export interface FilePickerFieldArguments
  extends FieldBaseArguments,
  Partial<{
    file?: FileInfo;
  }> { }

interface FileInfo {
  initialName?: string;
  currName?: string;
  currContent?: string;
  newName?: string;
  newContent?: string;
  newFile?: any;
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-generic-form/generic-editor/models/Field/FilePickerField.ts